import { checkIsTokenExists } from '../index'

const needAuth = auth => auth === true

export default (router) => {
  router.beforeEach((to, from, next) => {
    const auth = to.meta.requiresAuth

    if (!needAuth(auth)) {
      next()
      return
    }

    checkIsTokenExists()
      .then(() => next())
      .catch(() => next({ name: 'auth.singin' }))
  })
}



// WEBPACK FOOTER //
// ./src/app/auth/services/router/beforeEach.js